<template>
  <div class="analytics-page">
    <div class="chart-container">
      <div id="chart">
        <div class="flex justify-between items-center ">
          <h2 class="font-bold">{{ header }}</h2>
          <p>...</p>
        </div>
        <apexchart ref="chart" type="donut" :options="chartOptions" :series="series"></apexchart>      
     
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    keys: {
      type: Number,
    },
    showLabels: {
      type: Boolean,
    },
    showTotal: {
      type: String,
    },
    totalLabel: {
      type: Array,
    },
    header: {
      type: String,
    },
    series: {
      type: Array,
    },
    labels: {
      type: Array,
      required: true
    },
    colors: {
      type: Array,
      required: true
    },
    fontSize: {
      type: String,
      required: true
    }
  },


  data: function () {
    return {
      chartOptions:  {
        chart: {
          type: 'donut',
          height: 350
        },
        series: this.series,
        plotOptions: {
          pie: {
            donut: {
              labels: {
                show: this.showLabels,
                total: {
                  show: true,
                  label:  this.totalLabel || 'Total',
                 
                   formatter: (w) => {
                   const total = w.globals.seriesTotals.reduce((a, b) => a + b, 0);
                   return '₦' + total.toLocaleString(); 
                  } 
                }
              }
            }
          }
        },
        dataLabels: {
          enabled: false,
        },
        labels: this.labels,
        colors: this.colors,
        legend: {
          show: true,
          position: 'bottom',
          fontSize: this.fontSize,
          formatter: (seriesName, opts) => {
          const value = opts.w.globals.series[opts.seriesIndex];
          return seriesName + " - ₦" + value.toLocaleString();
          }
        }
      },
    }
  }
};
</script>

<style scoped>
.chart-container {
  padding: 30px;
}

</style>